import Table from "@/components/Table/table";
import { useColumnBallotDefs } from "./ballotDf";
import { useNavigate, useParams } from "react-router-dom";
import { useGetVotingBallotByCaseIDQuery } from "./votingReducer";
import { MotifButton, MotifProgressLoader } from "@ey-xd/motif-react";
import { useCustomCellRenderers } from "./constant/votingBallotCellconst";
import { useCallback, useEffect, useMemo, useState } from "react";
import CustomPagination from "@/components/Pagination/CustomPagination";
import {
  customPaginationPageSizeSelector,
  customTableLoadingData,
} from "@/components/Table/CustomPaginationConstants";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { havingAddPermission } from "@/utility/common";
import { setComponentState1 } from "@/features/retain_state/retainStateSlice";
import { paginationPageSize } from "@/Constant";

const TitleComplement = (Ballot: string[]) => {
  const navigate = useNavigate();
  const { caseId } = useParams<{
    caseId: string;
  }>();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  return havingAddPermission(Ballot) ? (
    <MotifButton
      onClick={() => {
        dispatch(
          setComponentState1({
            entityName: "creditorVotesTabState",
            entityState: {
              ballotVersionId: "",
              PageNumber: 1,
              SearchText: "",
              SortOrder: "asc",
              SortColumn: "VoterName",
              PageSize: paginationPageSize,
              sortedColumnTypes: {voterNameType:{ sort: "asc" }},
            },
          })
        );
        navigate(`/case/${caseId}/voting/create`, {
          state: { caseId },
        });
      }}
      size="small"
      type="submit"
      variant="secondary"
    >
      {t("pages.voting.createNewBallot")}{" "}
    </MotifButton>
  ) : (
    <></>
  );
};
export default function VotingTab() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isEdit, setIsEdit] = useState(false);

  const { caseId } = useParams<{
    caseId: string;
  }>();
  const dispatch = useDispatch();
  const permissions = useSelector((state: any) => state.permissions);
  const { Ballot } = permissions;
  let tableLoadingData = customTableLoadingData;
  const paginationPageSizeSelector: number[] = customPaginationPageSizeSelector;
  const retainState = useSelector((e: any) => e.retainState.ballotListTabState);
  const getPaginationObj: any = useMemo(() => {
    let value: any = {
      CaseId: caseId,
      PageNumber: retainState?.PageNumber || 1,
      PageSize: retainState?.PageSize,
      SearchText: retainState?.SearchText || "",
    };
    if (retainState?.SortOrder && retainState?.SortColumn) {
      value.SortOrder = retainState?.SortOrder;
      value.SortColumn = retainState?.SortColumn;
    }
    return value;
  }, [retainState, caseId]);
  const paginationObj = getPaginationObj;

  function handlePaginationData(data: any, columnTypesData: any) {
    dispatch(
      setComponentState1({
        entityName: "ballotListTabState",
        entityState: {
          SortOrder: data.SortOrder,
          SortColumn: data.SortColumn,
          sortedColumnTypes: columnTypesData,
        },
      })
    );
  }

  const { data, isLoading, isFetching, error, status } =
    useGetVotingBallotByCaseIDQuery(paginationObj);

  const sortedData = data?.results ? data?.results : [];

  const handleEditClick = useCallback(() => {
    setIsEdit(true);
  }, []);
  useEffect(() => {
    if (isEdit) {
      navigate(`/case/${caseId}/voting/edit`);
    }
  }, [isEdit, caseId, navigate]);
  const caseRenderers = useCustomCellRenderers(handleEditClick, Ballot);
  const columnBallotDefs = useColumnBallotDefs();
  return (
    <>
      {isLoading ? (
        <MotifProgressLoader show variant="default" className="mar-b-20" />
      ) : (
        <div className="mar-b-20">
          <Table
            columnTypes={{ ...retainState.sortedColumnTypes }}
            handlePaginationData={handlePaginationData}
            paginationObj={paginationObj}
            columnDefs={columnBallotDefs}
            cellRenderers={isFetching ? [] : sortedData}
            TitleComplement={() => TitleComplement(Ballot)}
            title={"pages.voting.tableTitle"}
            description={"pages.voting.tableDescription"}
            caseRenderers={caseRenderers}
            pagination={false}
            overlayNoRowsTemplate={
              isFetching
                ? t(tableLoadingData)
                : error
                ? t("global.globalNotifications.wentWrong")
                : t("global.globalNotifications.noRecords")
            }
          />
          <CustomPagination
            apiData={data}
            apiStatus={status}
            currentpage={paginationObj.PageNumber}
            pageSize={paginationObj.PageSize}
            disableNext={!data?.hasMoreRecords}
            onChangePageSize={(page: number) => {
              dispatch(
                setComponentState1({
                  entityName: "ballotListTabState",
                  entityState: {
                    PageSize: page,
                    PageNumber: 1,
                  },
                })
              );
            }}
            onChangeNextPage={() => {
              dispatch(
                setComponentState1({
                  entityName: "ballotListTabState",
                  entityState: {
                    PageNumber: paginationObj.PageNumber + 1,
                  },
                })
              );
            }}
            onChangePreviousPage={() => {
              dispatch(
                setComponentState1({
                  entityName: "ballotListTabState",
                  entityState: {
                    PageNumber: paginationObj.PageNumber - 1,
                  },
                })
              );
            }}
            pageSizeSelector={paginationPageSizeSelector}
          />
        </div>
      )}
    </>
  );
}
